/**
 * Chat Toggle Button
 * Floating button to open/close the chat panel
 */

import React from 'react';
import { MessageSquare } from 'lucide-react';

interface ChatToggleButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const ChatToggleButton: React.FC<ChatToggleButtonProps> = ({ isOpen, onClick }) => {
  if (isOpen) return null;

  return (
    <button
      onClick={onClick}
      className="fixed bottom-4 right-4 w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-105 z-40"
      title="Open Chat"
    >
      <MessageSquare className="w-6 h-6" />
    </button>
  );
};

export default ChatToggleButton;
